import { render, staticRenderFns } from "./missingCauses.vue?vue&type=template&id=6b5e1efe&"
import script from "./missingCauses.vue?vue&type=script&lang=js&"
export * from "./missingCauses.vue?vue&type=script&lang=js&"
import style0 from "./missingCauses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports